const config = (window as any)._app_;

const AppConfig = {
    baseUrl: config.BASE_URL,
    baseTabTitle: config.BASE_TAB_TITLE,
    apiPath: config.API_PATH,
    // katalog z gallery_public.php; domyślnie ten sam co pozostałe endpointy
    galleryApiPath: config.GALLERY_API_PATH || config.API_PATH,
};

export default AppConfig;